import HeroSection from './components/HeroSection';
import HotMoviesSection from './components/HotMoviesSection';
import HotTVShowsSection from './components/HotTVShowsSection';
import CategorySection from './components/CategorySection';
import NewsSection from './components/NewsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <HotMoviesSection />
      <CategorySection />
      <HotTVShowsSection />
      <NewsSection />
      <CTASection />
      <FAQSection />
    </>
  );
}